import { render, staticRenderFns } from "./PageBatch.vue?vue&type=template&id=5cd3e5e6"
import script from "./PageBatch.vue?vue&type=script&lang=js"
export * from "./PageBatch.vue?vue&type=script&lang=js"
import style0 from "./PageBatch.vue?vue&type=style&index=0&id=5cd3e5e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports